import { MenuItem } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { IItemRendererProps } from "@blueprintjs/select";
import _ from "lodash";
import { FormItemBuilderProperties, ItemRenderInputProperties } from "../Form";
import { get_icon, get_intent } from "./ItemSelect";

export const renderText = (
  property: any,
  bundle: FormItemBuilderProperties
) => {
  // console.log("renderText", { property, bundle });

  if (property === null || property === undefined)
    if (bundle.field_properties.placeholder)
      return bundle.field_properties.placeholder;
    else return "";

  let displayText = "";

  let value;
  if (property) {
    if (bundle.field_properties.itemKey)
      value = _.get(property, bundle.field_properties.itemKey);
    else value = property;
  } else if (bundle.field_properties.defaultValue)
    value = bundle.field_properties.defaultValue;

  if (bundle.field_properties.textRenderer) {
    // console.log("using textRenderer");
    displayText = bundle.field_properties.textRenderer(property);
  } else if (bundle.field_properties.translate) {
    displayText = _.get(bundle.field_properties.translate, value);
  } else displayText = value;

  // console.log("displayText", displayText);

  return displayText;
};

export const getIcon = (
  i: any | null,
  bundle: FormItemBuilderProperties<any>
) => {
  // console.log("getting icon for", i, bundle);

  if (i === null) {
    i = bundle.field_current_value || bundle.field_properties.defaultValue;
  }

  // console.log("getting icon for", i, bundle);

  if (typeof bundle.field_properties.icon === "function") {
    const ico = bundle.field_properties.icon(i);
    return ico;
  }
  if (bundle.field_properties.icon) return bundle.field_properties.icon;

  if (_.get(bundle.form_state, ["values", bundle.field_index]) === i) {
    return IconNames.CHEVRON_RIGHT;
  }

  return undefined;
};

export const renderItem: <
  ObjectPropertyType,
  ObjectType,
  X extends ItemRenderInputProperties<ObjectType, any>
>(
  property: ObjectPropertyType,
  bundle: FormItemBuilderProperties<ObjectType, X>
) => any = (property, bundle) => {
  if (bundle.field_properties.itemRenderer)
    return bundle.field_properties.itemRenderer(
      property,
      bundle.field_root_value,
      bundle.form_submitting,
      (item) => {
        bundle.update_value(item);
      }
    );

  return renderText(property, bundle);
};

export const ItemRenderer: <
  ObjectPropertyType,
  ObjectType,
  X extends ItemRenderInputProperties<ObjectType, ObjectPropertyType> = any
>(
  bundle: FormItemBuilderProperties<ObjectType, X>,
  property: ObjectPropertyType | null,
  render_props: IItemRendererProps
) => JSX.Element = (bundle, property, { handleClick, modifiers, query }) => {
  if (property === null || property === undefined) return <></>;

  const value = bundle.field_properties.itemKey
    ? _.get(property, bundle.field_properties.itemKey)
    : property;

  const id = _.get(property, "id", value);

  // console.log("rendering item", typeof i, i, value, bundle);

  let node;
  if (typeof property !== "string") {
    node = renderItem(property, bundle);
  } else {
    node = HighlightText(renderText(property, bundle), query);
  }

  return (
    <MenuItem
      active={modifiers.active}
      disabled={bundle.form_submitting}
      key={id}
      style={{ minWidth: 100 }}
      text={node}
      onClick={handleClick}
      icon={get_icon(bundle, property)}
      intent={get_intent(bundle, property)}
    />
  );
};

export const EscapeRegExpChars = (text: string) =>
  text.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");

export const HighlightText = (text: string, query: string) => {
  let lastIndex = 0;
  const words = query
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .map(EscapeRegExpChars);
  if (words.length === 0) {
    return [text];
  }
  const regexp = new RegExp(words.join("|"), "gi");
  const tokens: React.ReactNode[] = [];
  while (true) {
    const match = regexp.exec(text);
    if (!match) {
      break;
    }
    const length = match[0].length;
    const before = text.slice(lastIndex, regexp.lastIndex - length);
    if (before.length > 0) {
      tokens.push(before);
    }
    lastIndex = regexp.lastIndex;
    tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
  }
  const rest = text.slice(lastIndex);
  if (rest.length > 0) {
    tokens.push(rest);
  }
  return tokens;
};
